// Centralised access to the JWT auth token.
//
// All app code should import from this module instead of calling
// `localStorage.getItem('token')` directly. This isolates the storage
// concern in ONE place so a future migration to httpOnly cookies (or
// in-memory + refresh-token rotation) only requires editing this file.
//
// Why a thin wrapper rather than a full httpOnly migration today?
//   • httpOnly cookies require coordinated changes to the FastAPI auth
//     flow (Set-Cookie on /auth/login, CSRF handling, SameSite policy).
//     That is its own integration playbook and a separate commit.
//   • Centralising the access pattern is a strict prerequisite for that
//     migration — without it, the migration is a 175-file blind sweep.

const TOKEN_KEY = 'token';

export function getAuthToken() {
  try {
    return window.localStorage.getItem(TOKEN_KEY);
  } catch {
    return null;
  }
}

export function setAuthToken(token) {
  try {
    window.localStorage.setItem(TOKEN_KEY, token);
  } catch {
    // Storage unavailable (private mode / quota) — silently degrade.
  }
}

export function clearAuthToken() {
  try {
    window.localStorage.removeItem(TOKEN_KEY);
  } catch {
    // ignore
  }
}

// Convenience: returns the standard Authorization header object,
// shaped for axios `{ headers: authHeaders() }`.
export function authHeaders() {
  const t = getAuthToken();
  return t ? { Authorization: `Bearer ${t}` } : {};
}
